import { render } from "./index.vue?vue&type=template&id=06500efa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=06500efa&lang=css"
import "./index.vue?vue&type=style&index=1&id=06500efa&scoped=true&lang=scss"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06500efa"]])

export default __exports__